import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        {...rest}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, testId }) => (
    <p
        data-testid={testId}
        className="mb-6 flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.28em] text-brand"
    >
        <span className="h-px w-8 bg-brand/60" aria-hidden />
        {children}
    </p>
);

export const PageHeader = ({ eyebrow, title, sub }) => (
    <section className="relative overflow-hidden border-b border-slate-200 bg-white">
        <div className="hero-grid absolute inset-0" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-4 pb-20 pt-36 sm:px-8 sm:pb-24 sm:pt-44 lg:px-16">
            <Reveal>
                <Eyebrow testId={`${eyebrow.toLowerCase().replace(/\s+/g, "-")}-eyebrow`}>{eyebrow}</Eyebrow>
                <h1 className="max-w-4xl font-display text-4xl font-bold leading-[1.08] tracking-tight text-balance text-slate-900 sm:text-5xl lg:text-6xl">
                    {title}
                </h1>
                {sub && (
                    <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
                        {sub}
                    </p>
                )}
            </Reveal>
        </div>
    </section>
);
